const styles = () => ({
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        cursor: 'pointer',
        fontSize: '12px',
        justifyContent: 'space-between',
    },
    internalContainer: {
        minHeight: '340px',
    },
    date: {
        margin: '0',
        fontWeight: 'bold',
    },
    request: {
        textAlign: 'right',
        fontStyle: 'italic',
        margin: '0',
    },
    boxDescription: {
        width: '100%',
    },
    description: {
        width: '100%',
        margin: '0',
        fontWeight: 'bold',
    },
    centerProgress: {
        textAlign: 'center',
        margin: '30px 0 10px',
    },
});

export default styles;
